var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportVec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7288 0L18 5.274V12.7298L12.7288 18H5.27305L0 12.7288V5.27305L5.27305 0H12.7288ZM11.9435 1.89474H6.05747L1.89568 6.05842V11.9444L6.05747 16.1072H11.9435L16.1062 11.9444V6.05747L11.9435 1.89568V1.89474ZM8.05263 11.8421H9.94737V13.7368H8.05263V11.8421ZM8.05263 4.26316H9.94737V9.94737H8.05263V4.26316Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportVec);
export default __webpack_public_path__ + "static/media/report-vec.6d2a4f66b5290df7e78c83abf8af3c76.svg";
export { ForwardRef as ReactComponent };